/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_GsmInputs */

const cs_sreality_seller_gsm = /** @type {(inputs: Sreality_Seller_GsmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil (Sreality GSM)`)
};

const en_sreality_seller_gsm = /** @type {(inputs: Sreality_Seller_GsmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile (Sreality GSM)`)
};

/**
* | output |
* | --- |
* | "Mobile (Sreality GSM)" |
*
* @param {Sreality_Seller_GsmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_gsm = /** @type {((inputs?: Sreality_Seller_GsmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_GsmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_gsm(inputs)
	return cs_sreality_seller_gsm(inputs)
});